import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsBoost from 'highcharts/modules/boost';
import { IDonutGraph } from '../../../interfaces/charts/trader-advisor.interface';

@Component({
    selector: 'traderadvisor-donut',
    templateUrl: './traderadvisor-donut.component.html',
    styleUrls: ['./traderadvisor-donut.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TraderadvisorDonutComponent implements OnInit {
    @Input() public options: IDonutGraph;

	constructor() {
		HighchartsBoost(Highcharts);
		HighchartsMore(Highcharts);
	}

    ngOnInit() {
        try {
            if(this.options) {
                Highcharts.chart('hc-donut',
                {
                    chart: {
                        height: '150',
                        type: 'pie',
                    },
                    title: {
                        text: '',
                    },
                    lang: {
                        noData: 'Sem dados para exibir'
                    },
                    plotOptions: {
                        pie: {
                            shadow: false,
                            center: ['50%', '55%'],
                            size: '250',
                            minSize: 150,
                            animation: false,
                        }
                    },
                    tooltip: {
                        enabled: true,
                        valueSuffix: '%'
                    },
                    series: [{
                        name: 'Taxa de acerto',
                        type: 'pie',
                        data: [
                            { name: "Acerto", y: this.options.accuracy <= 100 ? this.options.accuracy : 100, color: "#9860F8" },
                            { name: "Erro", y: this.options.accuracy <= 100 ? 100 - this.options.accuracy : 0, color: "#F5EFFF" },
                        ],
                        size: '130%',
                        innerSize: '75%',
                        dataLabels: {
                            enabled: false
                        },
                    }],
                });
            }
        } catch (error) {
            throw error;
        }
    }
}
